import Button from 'components/Button'
import Text from 'components/Text'
import { View } from 'components/View'
import React from 'react'
import Row from 'components/Row.js'

/**
 * @param text
 * @param subText
 * @param isSelected
 * @param onClick
 * @param textStyle
 * @param textProps
 * @param style
 * @param left
 * @returns {JSX.Element}
 * @constructor
 */
export default function OptionButton ({
  text,
  subText,
  isSelected,
  onClick,
  textStyle,
  style,
  left,
  textProps = {}
}) {
  return (
    <Button
      onClick={onClick}
      isFullWidth
      style={{
        background: isSelected ? '#F6F6F6' : '#FFFFFF',
        borderRadius: '10px',
        alignItems: 'center',
        width: '100%',
        padding: '0 1rem',
        ...style
      }}
    >

      <Row ac>
        {
          !!left && (
            <View mr={2}>{left}</View>
          )
        }

        <View
          style={{
            alignItems: 'flex-start',
            textAlign: 'left'
          }}
        >
          <Text
            fw='540'
            c='#151D21'
            fs='0.9375em'
            {...textProps}
            style={{ textTransform: 'uppercase', ...textStyle }}
          >
            {text}
          </Text>

          {
            subText && (
              <Text
                fs='0.6875em'
                fw='400'
                mt='3px'
                c='#151D21'
              >
                {subText}
              </Text>
            )
          }
        </View>
      </Row>
    </Button>
  )
}
